class CustomSlider extends HTMLElement {
    constructor() {
        super();

        const customImageSlider = document.getElementById('custom-image-slider');
        
        if (!customImageSlider) {
            console.error("Element with ID 'custom-image-slider' not found.");
            return;
        }

        const sliderPagination = customImageSlider.dataset.sliderPagination === 'true';
        const sliderArrow = customImageSlider.dataset.sliderArrow === 'true';
        const sliderAutoplay = customImageSlider.dataset.sliderAutoplay === 'true';
      
        this.flkty = new Flickity(this.querySelector(".flickty-wrapper"), {
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            autoPlay: sliderAutoplay ? 3000 : false,
            pauseAutoPlayOnHover: true,
            pageDots: sliderPagination,
            prevNextButtons: sliderArrow
        });
    }
    
}

customElements.define('custom-slider', CustomSlider);
